import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PageTransition from '../PageTransition/PageTransition';
import Logo from '../Logo/Logo';
import PoloShowcase from '../PoloShowcase/PoloShowcase';
import { useIsMobile } from '../../hooks/useMediaQuery';

/**
 * 响应式布局 - 对标燃油计算器 app-shell 结构
 */
export default function AppLayout() {
  const location = useLocation();
  const isMobile = useIsMobile();
  const isRecords = location.pathname.startsWith('/admin') || location.pathname.startsWith('/records');
  const isApply = location.pathname === '/apply';
  const isSuccess = location.pathname === '/success';
  const showShowcase = !isRecords && !isApply && !isSuccess;
  const showBottomBrand = !isRecords;
  const isHome = location.pathname === '/';
  const contentStatic = (isHome || isSuccess) && !isRecords;
  const isApplyH5 = isMobile && isApply;

  useEffect(() => {
    document.documentElement.classList.toggle('app-page-flow-apply', isApplyH5);
    return () => document.documentElement.classList.remove('app-page-flow-apply');
  }, [isApplyH5]);

  const contentClass = [
    'app-content',
    contentStatic && 'app-content--static',
    isMobile && isSuccess && 'app-content--success-h5',
  ].filter(Boolean).join(' ');

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header-inner">
          <div className="app-header-deco app-header-deco--left" aria-hidden="true" />
          <div className="app-header-deco app-header-deco--right" aria-hidden="true" />
          <div className="app-title-wrap">
            <Logo size={isMobile ? 52 : 64} className="app-title-logo" />
            <div className="app-title-text">
              <h1>Workwear Benefits</h1>
              <h2 className="app-header-title">在途 · 企业工装福利申领</h2>
              <p className="app-header-tagline">企业关怀福利 · 在线登记尺码</p>
            </div>
          </div>
          <div className="app-header-accent" aria-hidden="true" />
        </div>
      </header>

      <main className={contentClass}>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>

      {showBottomBrand && (
        <div className="app-bottom-panel">
          <div
            className={`app-showcase-slot${showShowcase ? ' app-showcase-slot--active' : ' app-showcase-slot--empty'}`}
            aria-hidden={!showShowcase}
          >
            {showShowcase && <PoloShowcase />}
          </div>
          <footer className="app-footer">
            <div className="footer-inner">
              <div className="footer-logo-row">
                <div className="footer-logo-slot footer-logo-slot--zaitu">
                  <img className="footer-logo-zaitu" src="/logo-zaitu.svg" alt="在途商旅" />
                </div>
                <div className="footer-logo-slot footer-logo-slot--lefu">
                  <img className="footer-logo-lefu" src="/logo-lefu.svg" alt="乐福集采" />
                </div>
              </div>
              <p className="footer-tagline">行在途 · 享乐福</p>
            </div>
          </footer>
        </div>
      )}
    </div>
  );
}
